import { Icon } from "@iconify/react";          
import { Link } from "react-router-dom";

export default function ImageAndText({ image, headline, text, button }) {
	const HeadingTag = headline.type;

	return (
		<section className="ce_imageandtext">
			<div className="container">
				<div className="row">
					<div className="col-12 col-lg-6 image">
						<img src={image} />
					</div>
					<div className="col-12 col-lg-6 text">
						<HeadingTag
							dangerouslySetInnerHTML={{ __html: headline.text }}
						/>
						<div
							dangerouslySetInnerHTML={{ __html: text }}
						/>   
						<div>
							<Link className="btn-red" to={button.href}>
								{button.text}
								<svg width="17" height="12" viewBox="0 0 17 12" fill="none" xmlns="http://www.w3.org/2000/svg">
								<path fill-rule="evenodd" clip-rule="evenodd" d="M0.5 5.97834C0.5 5.74802 0.593655 5.52713 0.760362 5.36427C0.927069 5.20141 1.15317 5.10992 1.38893 5.10992H13.4666L10.2427 1.96044C10.0857 1.79582 10.0002 1.57808 10.0043 1.3531C10.0083 1.12812 10.1016 0.913465 10.2645 0.754355C10.4274 0.595245 10.6471 0.504105 10.8774 0.500135C11.1077 0.496166 11.3305 0.579677 11.4991 0.733075L16.24 5.36465C16.4065 5.52748 16.5 5.74821 16.5 5.97834C16.5 6.20847 16.4065 6.42919 16.24 6.59202L11.4991 11.2236C11.4177 11.3089 11.3195 11.3774 11.2105 11.4248C11.1015 11.4723 10.9837 11.4978 10.8644 11.4999C10.745 11.5019 10.6265 11.4805 10.5158 11.4368C10.4051 11.3931 10.3045 11.3281 10.2201 11.2456C10.1357 11.1632 10.0692 11.065 10.0245 10.9568C9.97976 10.8487 9.9578 10.7329 9.95991 10.6163C9.96202 10.4997 9.98814 10.3847 10.0367 10.2781C10.0853 10.1716 10.1554 10.0757 10.2427 9.99623L13.4666 6.84676H1.38893C1.15317 6.84676 0.927069 6.75526 0.760362 6.5924C0.593655 6.42954 0.5 6.20866 0.5 5.97834Z" fill="white"/>
								</svg>

							</Link>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
